<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
$(document).ready(function() {
  if(window.location.hash == '#recover'){
    $("html, body").animate({ scrollTop: 100 }, "slow");
  }
  $('.forget-password,.cancel').click(function(){
    $("html, body").animate({ scrollTop: 100 }, "slow");
  });

  
});
